module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('main', {
    staticClass: "main-container flexContainer t-fd-r full m-fd-c"
  }, [_c('section', {
    staticClass: "flexContainer primary-bloc fd-c size12of12 col m-w-full"
  }, [_c('div', {
    staticClass: "flexContainer full jc-fe m-jc-c"
  }, [_c('div', {
    staticClass: "content-button"
  }, [_c('router-link', {
    staticClass: "btn pointer uppercase create",
    attrs: {
      "tag": "button",
      "to": "/plano/config/carcass"
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("displayer.create")))])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "flexContainer full"
  }, [_c('List', {
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flexContainer full jc-fe m-jc-c"
  }, [_c('div', {
    staticClass: "content-button"
  }, [_c('router-link', {
    staticClass: "btn pointer uppercase create",
    attrs: {
      "tag": "button",
      "to": "/plano/config/carcass"
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("displayer.create")))])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6923bc55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/displayers/Displayers.vue
// module id = 3243
// module chunks = 0